import groq from 'groq'
import pageFields from '../fields/page'
import productFields from '../fields/product'

export default groq`
  *[_type == "product"]{
    ...${pageFields},
    ...${productFields}
  }
`
